import { object, string } from "yup";
import { LICENCIAS_CONDUCIR } from "../../../../constants/contexts";

export const FormikInitialValues = {
	valor: "",
	contexto: LICENCIAS_CONDUCIR,
}

export const FormikValidationSchema = object().shape({
	valor: string()
		.min(1, ({ min }) => `La licencia de conducir debe tener al menos ${min} caracteres.`)
		.max(200, ({ max }) => `La licencia de conducir debe tener a lo más ${max} caracteres.`)
		.required("La licencia de conducir es requerida."),
});